import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/Login';
import Main from '@/views/Main';
import BaseView from '@/components/main/BaseView';
import Dashboard from '@/views/Dashboard';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Login
  },
  {
    path: "/",
    component: Main,
    beforeEnter(to, from, next) {
      if (store.state.token) {
        next();
      } else {
        next("/");
      }
    },
    children: [
      { 
        path: '/dashboard', 
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      { 
        path: '/system_role',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-system_role',
            component: () => import("@/views/system_role/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-system_role',
              component: () => import("@/views/system_role/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/system_user',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-system_user',
            component: () => import("@/views/system_user/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-system_user',
              component: () => import("@/views/system_user/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/configuration',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-configuration',
            component: () => import("@/views/configuration/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-configuration',
              component: () => import("@/views/configuration/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/app_user',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-app_user',
            component: () => import("@/views/app_user/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-app_user',
              component: () => import("@/views/app_user/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: "active",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    $(".preloader").children().show();
    $(".preloader").css('height', '100%');
  
    setTimeout(function () {  
      $(".preloader").css('height', 0);      
      setTimeout(function () {
        $(".preloader").children().hide();
      }, 200);
    }, 500);
  
    if (store.state.token) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;